import { useQuery } from "@tanstack/react-query";
import { PRICING_POC_FACETS_QUERY_KEY } from "../constants";
import { PricingWorkloadService } from "../services/PricingWorkload.service";

export default function useGetPricingPocFacets(briefId: string, pocId: string) {
  const { data, isFetching, error, refetch } = useQuery({
    queryKey: PRICING_POC_FACETS_QUERY_KEY(briefId, pocId),
    queryFn: () => PricingWorkloadService.getPricingPocFacets(briefId, pocId),
    enabled: !!briefId && !!pocId,
  });
  return {
    pricingPocFacets: data,
    isPricingPocFacetsLoading: isFetching,
    isPricingPocFacetsError: error,
    refetchPricingPocFacets: refetch,
  };
}
